import { useStores } from "stores/rootStore";

export function useOrgId(): number {
  const { orgStore } = useStores();
  return orgStore.selectedOrg?.id ?? 0;
}
